import React from "react";
import { arrayOf, shape, string } from "prop-types";
import { connect } from "react-redux";
import Resources from "../../components/Resources";

import { findUmbraccoResources } from "./util";

const ResourcesLabourSlaveContainer = ({ resources }) => {
  const requiredResources = findUmbraccoResources(
    resources,
    "Help reduce exploitation ",
    "Labour exploitation - Spot the signs",
    "Examples of modern slavery videos",
    "Just good work",
    "Working in the UK - Your Rights"
  );

  const res = [...(requiredResources || [])];

  res.unshift(
    ...findUmbraccoResources(
      resources,
      "Working in the UK, worker induction video"
    )
  );

  return (
    <Resources resources={res} title="Labour exploitation & modern slavery" />
  );
};

ResourcesLabourSlaveContainer.propTypes = {
  resources: arrayOf(
    shape({
      title: string.isRequired,
      description: string.isRequired,
      link: string,
      cta: string,
    })
  ),
};

const mapStateToProps = (state) => ({
  resources: state.core.umbracoContent.resources,
});

const mapDispatchToProps = {};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ResourcesLabourSlaveContainer);
